<h1 mat-dialog-title>{{ 'DIALOG_PERMISSION.TITLE' | translate }}</h1>
<div mat-dialog-content>{{ 'DIALOG_PERMISSION.DESCRIPTION' | translate }}</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="nextStep()" mat-dialog-close>{{ 'DIALOG_PERMISSION.BUTTON_CONFIRM' | translate }}</button>
  <button mat-button mat-dialog-close>{{ 'DIALOG_PERMISSION.BUTTON_CLOSE' | translate }}</button>
</div>
